import React from 'react'
import {URL} from 'whatwg-url'
import Config from 'mb-app-common/lib/config'
import redirect from '../../lib/redirect'

import CenterSpinner from '../layout/CenterSpinner'

export default () => {
	redirect(new URL('/home', Config.CLIENT_WEB))

	return <CenterSpinner size="100px"/>
}



// WEBPACK FOOTER //
// ./client/components/Home/index.js